import OneliveMobileMypageShell from './OneliveMobileMypageShell';

export default function OneliveMobileMessagesPage() {
  return (
    <OneliveMobileMypageShell>
      <div className="onelive-mypage-history">
        <h3 className="onelive-mypage-history-title">쪽지함</h3>
        <p className="onelive-mypage-empty">받은 쪽지가 없습니다.</p>
      </div>
    </OneliveMobileMypageShell>
  );
}
